import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "es", label: "ES", flag: "\ud83c\uddea\ud83c\uddf8" },
  { code: "en", label: "EN", flag: "\ud83c\uddfa\ud83c\uddf8" },
  { code: "pt", label: "PT", flag: "\ud83c\udde7\ud83c\uddf7" },
];

const LanguageSwitcher = ({ variant = "light" }) => {
  const { i18n } = useTranslation();

  const currentLang =
    languages.find((l) => l.code === i18n.language) || languages[0];

  const handleChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const isDark = variant === "dark";

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant={isDark ? "outline-light" : "outline-secondary"}
        size="sm"
        id="language-dropdown"
        style={{ minWidth: "70px" }}
      >
        {currentLang.flag} {currentLang.label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            active={lang.code === i18n.language}
            onClick={() => handleChange(lang.code)}
          >
            {lang.flag} {lang.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
